import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NavComponent } from 'src/app/traits/nav/nav.component';
import { ManagerService } from 'src/app/services/manager.service';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.css']
})
export class GroupsComponent implements OnInit {
  groups: any; filteredGroup: any[] = []; response: any; search: string = '';
  private _searhcTitle: string;

  get searchTitle(): string {
    return this._searhcTitle;
  }
  set searchTitle(value: string) {
    this._searhcTitle = value;
    // this.search = value;
    this.getMore(1,10);
    // this.filteredGroup = this.serachResult(value);
  }
  constructor(private api: ApiService, private use: NavComponent, private _exp: ExportExcelService) { }

  ngOnInit() {
    this.getAllGroups();
  }

  getAllGroups() {
    this.api.get('icare').subscribe((data: any) => {
      this.groups = data; this.response = data; console.log(data);
      this.filteredGroup = this.groups.data;
    }, (err: HttpErrorResponse) => {
      this.use.showMsg('error', 'iCare List Fail', 'Unable to Fetch iCare List');
    });
  }

  getMore(page,limit) {
    this.api.get('icare?search='+this.search+'&page='+page+'&limit='+limit).subscribe((data: any) => {
      this.groups = data; this.response = data; console.log(data);
      this.filteredGroup = this.groups.data;
    }, (err: HttpErrorResponse) => {
      this.use.showMsg('error', 'iCare List Fail', 'Unable to Fetch iCare List');
    });
  }

  
  reset(val) {
    val.pin = '1234';
    this.api.put('icare/'+val.groupid, val).subscribe((data: any) => {
      this.use.showMsg('success', 'Pin Reset', 'iCare Pin Reset Successfully');
    }, (err: HttpErrorResponse) => {
      this.use.showMsg('error', 'Pin Reset Fail', 'Unable to Reset iCare Pin');
    });
  }
  
  Export() {
    this.Sort().then((data)=>{
      // return data;
      this._exp.exportAsExcelFile(data, 'icare');
    });
    // this._exp.exportAsExcelFile(this.filteredGroup, 'group');
  }

  async Sort() {
    const groups = [];
    await this.filteredGroup.forEach((c)=>{
      const grp = { 
        code: c.code, name: c.name, leader: c.group_leader, mobile: c.mobile, secretary: c.group_secretary, secretary_mobile: c.group_secretary_mobile, status: c.active == true? 'Active': 'Disabled', creationTime: c.date 
      };
        groups.push(grp);
    });
    return groups;
  }

  serachResult(searchString: string) {
    // tslint:disable-next-line:max-line-length
    return this.groups.filter(a => a.number.toLowerCase().indexOf(searchString.toLocaleLowerCase()) !== -1 || a.customer.fullname.toLowerCase().indexOf(searchString.toLocaleLowerCase()) !== -1 || a.status.toLowerCase().indexOf(searchString.toLocaleLowerCase()) !== -1 || a.grouptype.name.toLowerCase().indexOf(searchString.toLocaleLowerCase()) !== -1 || a.grouptype.basetype.toLowerCase().indexOf(searchString.toLocaleLowerCase()) !== -1);
  }

}
